import { SUPPORTED_ENVIRONMENT } from '@/_config';

import { getErrors } from './error';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function getFriendlyMessageForApis(payload: any, error: any) {
  const { status, data, error: errorCause, originalStatus, response } = payload;
  const { message } = error || {};

  if (import.meta.env.VITE_ENVIRONMENT !== SUPPORTED_ENVIRONMENT.PRODUCTION) {
    console.log(payload, error);
  }

  if (status === 'FETCH_ERROR') {
    if (errorCause !== 'TypeError: Failed to fetch') {
      return { msg: 'No Internet, Please check your connection and try again.', type: 'SEVERE' };
    }

    if (message === 'Rejected') {
      return { msg: "CORS: Couldn't fetch the data. Please contact the Admin", type: 'SEVERE' };
    }

    return { msg: "CORS: Couldn't fetch the data. Please contact the Admin", type: 'SEVERE' };
  }

  if (originalStatus >= 500 || status === 'PARSING_ERROR' || status >= 500) {
    return { msg: 'Something went wrong, please try again later', type: 'SEVERE' };
  }

  const errorResponse = response || data || errorCause;

  if (errorResponse) {
    if (errorResponse.error_code === '9999') {
      return { msg: getErrors(errorResponse), type: 'NORMAL' };
    }

    if (errorResponse.status && errorResponse.status === 'notfound') {
      return { msg: 'User not found.', type: 'NORMAL' };
    }

    return { msg: getErrors(errorResponse), type: 'NORMAL' };
  }

  return { msg: 'Something went wrong, please try again later', type: 'SEVERE' };
}
